module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg35.1dd1bff4.jpg";